<template>
  <!-- [sc-49299] Campi del nuovo articolo: pagina dei listini e creazione dal
       preventivo -->
  <div class="form-articolo">
    <!-- ── Campi comuni ─────────────────────────────────────────── -->
    <div class="create-item-row">
      <div class="field">
        <label for="item-code">Codice articolo *</label>
        <input
          id="item-code"
          type="text"
          v-model.trim="form.itemCode"
          placeholder="es. ART-001"
          maxlength="255"
          required
        />
      </div>
      <div class="field">
        <label for="item-name">Nome articolo *</label>
        <input
          id="item-name"
          type="text"
          v-model.trim="form.itemName"
          placeholder="inserisci"
        />
        <small class="help-note">Oppure il brand: basta uno dei due</small>
      </div>
    </div>

    <div class="create-item-row">
      <div class="field">
        <label for="brand">Brand</label>
        <input
          id="brand"
          type="text"
          v-model="form.brand"
          placeholder="inserisci"
        />
      </div>
      <div class="field">
        <label for="serie">Serie</label>
        <input
          id="serie"
          type="text"
          v-model="form.serie"
          placeholder="inserisci"
        />
      </div>
      <div class="field">
        <label for="articleStatus">Stato</label>
        <StatusSelect
          v-model="form.articleStatus"
          :options="articleStatusOptions"
        />
      </div>
    </div>

    <!-- Prezzi: IVA esclusa -->
    <div class="create-item-row">
      <div class="field">
        <label for="price">Prezzo listino *</label>
        <input
          id="price"
          type="number"
          step="any"
          min="0"
          v-model.number="form.price"
          placeholder="inserisci"
          :class="{ invalid: vendita.errori.price }"
        />
        <small v-if="vendita.errori.price" class="help-error">{{
          vendita.errori.price
        }}</small>
        <small v-else class="help-note">IVA esclusa</small>
      </div>
      <div class="field">
        <label for="priceDiscounted">Prezzo scontato</label>
        <input
          id="priceDiscounted"
          type="number"
          step="0.01"
          min="0"
          v-model="form.priceDiscounted"
          placeholder="facoltativo"
          :class="{ invalid: erroreScontato }"
        />
        <small v-if="erroreScontato" class="help-error">{{
          erroreScontato
        }}</small>
        <small v-else class="help-note">IVA esclusa</small>
      </div>
      <!-- [sc-49299] l'unità di vendita decide quali misure servono -->
      <div class="field">
        <label for="salesUnit">Venduto a *</label>
        <StatusSelect v-model="form.salesUnit" :options="unitaVendita" />
        <small
          v-if="avvisoUnita(category, form.salesUnit)"
          class="help-warning"
          >{{ avvisoUnita(category, form.salesUnit) }}</small
        >
      </div>
    </div>

    <hr />

    <!-- ── Gruppo AREA ── -->
    <template v-if="categoryGroup === 'area'">
      <div class="create-item-row">
        <div class="field">
          <label for="formatLabel">Formato (es. 60x120)</label>
          <input
            id="formatLabel"
            type="text"
            v-model="form.formatLabel"
            placeholder="es. 60x120"
          />
        </div>
        <div class="field">
          <label for="thicknessMm">Spessore (mm)</label>
          <input
            id="thicknessMm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.thicknessMm"
            placeholder="es. 10"
          />
        </div>
        <div class="field">
          <label for="surface">Superficie</label>
          <input
            id="surface"
            type="text"
            v-model="form.surface"
            placeholder="es. Matt, Lucido"
          />
        </div>
      </div>
      <div class="create-item-row">
        <div class="field">
          <label for="color">Colore</label>
          <input
            id="color"
            type="text"
            v-model="form.color"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="piecesPerBox"
            >Pz / scatola{{
              richiesto(form.salesUnit, "piecesPerBox") ? " *" : ""
            }}</label
          >
          <input
            id="piecesPerBox"
            type="number"
            min="0"
            v-model.number="form.piecesPerBox"
            placeholder="inserisci"
            :class="{ invalid: vendita.errori.piecesPerBox }"
          />
          <small v-if="vendita.errori.piecesPerBox" class="help-error">{{
            vendita.errori.piecesPerBox
          }}</small>
        </div>
        <div class="field">
          <label for="sqmPerBox"
            >M² / scatola{{
              richiesto(form.salesUnit, "sqmPerBox") ? " *" : ""
            }}</label
          >
          <input
            id="sqmPerBox"
            type="number"
            step="any"
            min="0"
            v-model.number="form.sqmPerBox"
            placeholder="inserisci"
            :class="{ invalid: vendita.errori.sqmPerBox }"
          />
          <small v-if="vendita.errori.sqmPerBox" class="help-error">{{
            vendita.errori.sqmPerBox
          }}</small>
        </div>
      </div>
    </template>

    <!-- ── Gruppo PIECE ── -->
    <template v-if="categoryGroup === 'piece'">
      <div class="create-item-row">
        <div v-if="category === 'sanitari'" class="field">
          <label for="fixtureType">Tipo</label>
          <StatusSelect
            v-model="form.fixtureType"
            :options="fixtureTypeOptions"
          />
        </div>
        <div v-if="category === 'sanitari'" class="field">
          <label for="fixturePosition">Posizione</label>
          <StatusSelect
            v-model="form.fixturePosition"
            :options="fixturePositionOptions"
          />
        </div>
        <div class="field">
          <label for="finish">Finitura</label>
          <input
            id="finish"
            type="text"
            v-model="form.finish"
            placeholder="es. Cromo, Nero opaco"
          />
        </div>
        <div class="field">
          <label for="color">Colore</label>
          <input
            id="color"
            type="text"
            v-model="form.color"
            placeholder="inserisci"
          />
        </div>
      </div>
    </template>

    <!-- ── Gruppo LINEAR ── -->
    <template v-if="categoryGroup === 'linear'">
      <div class="create-item-row">
        <div class="field">
          <label for="material">Materiale</label>
          <input
            id="material"
            type="text"
            v-model="form.material"
            placeholder="es. Alluminio, Inox"
          />
        </div>
        <div class="field">
          <label for="lengthMm">Lunghezza (mm)</label>
          <input
            id="lengthMm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.lengthMm"
            placeholder="es. 2500"
          />
        </div>
        <div class="field">
          <label for="mlPerBox"
            >ML / confezione{{
              richiesto(form.salesUnit, "mlPerBox") ? " *" : ""
            }}</label
          >
          <input
            id="mlPerBox"
            type="number"
            step="any"
            min="0"
            v-model.number="form.mlPerBox"
            placeholder="es. 2.5"
            :class="{ invalid: vendita.errori.mlPerBox }"
          />
          <small v-if="vendita.errori.mlPerBox" class="help-error">{{
            vendita.errori.mlPerBox
          }}</small>
        </div>
      </div>
    </template>

    <!-- ── Gruppo FURNITURE ── -->
    <template v-if="categoryGroup === 'furniture'">
      <div class="create-item-row">
        <div class="field">
          <label for="widthCm">Larghezza (cm)</label>
          <input
            id="widthCm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.widthCm"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="heightCm">Altezza (cm)</label>
          <input
            id="heightCm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.heightCm"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="material">Materiale</label>
          <input
            id="material"
            type="text"
            v-model="form.material"
            placeholder="es. MDF, Rovere"
          />
        </div>
        <div class="field">
          <label for="finish">Finitura</label>
          <input
            id="finish"
            type="text"
            v-model="form.finish"
            placeholder="es. Bianco opaco"
          />
        </div>
      </div>
    </template>

    <!-- ── Gruppo GENERIC ── -->
    <template v-if="categoryGroup === 'generic'">
      <div class="create-item-row">
        <div class="field">
          <label for="notes">Note</label>
          <textarea
            id="notes"
            v-model="form.notes"
            placeholder="inserisci"
            rows="3"
          />
        </div>
      </div>
    </template>

    <!-- [sc-49299] giacenza iniziale: vuota = 0. Solo per chi gestisce prezzi
         e magazzino; per Vendita l'articolo parte da 0 -->
    <hr v-if="caricaGiacenza" />

    <div v-if="caricaGiacenza" class="create-item-row">
      <div class="field">
        <label for="giacenza-iniziale">{{ giacenza.label }} in magazzino</label>
        <input
          id="giacenza-iniziale"
          type="number"
          step="1"
          min="0"
          v-model="form[giacenza.campo]"
          placeholder="0"
          :class="{ invalid: erroreGiacenza }"
        />
        <small v-if="erroreGiacenza" class="help-error">{{
          erroreGiacenza
        }}</small>
        <small v-else class="help-note">Facoltativa: vuota vale 0</small>
      </div>
    </div>
  </div>
</template>

<script>
import StatusSelect from "@/components/StatusSelect.vue";
import {
  avvisoUnita,
  controlloVendita,
  haNomeOBrand,
  richiesto,
  unitaIniziale,
  unitaPerCategoria,
} from "@/utilities/venditaArticolo";
import { erroreScontato, numeroPrezzo } from "@/utilities/prezzoArticolo";
import {
  campoGiacenza,
  erroreGiacenzaIniziale,
  puoCaricareGiacenza,
  getCategoryGroup,
} from "@/utilities/categorieArticolo";

const formVuoto = (category, itemName = "") => ({
  itemCode: "",
  itemName,
  brand: "",
  serie: "",
  // vuoto, non 0: il prezzo è obbligatorio [sc-49299]
  price: null,
  salesUnit: unitaIniziale(category),
  priceDiscounted: null,
  articleStatus: "attivo",
  formatLabel: "",
  thicknessMm: null,
  surface: "",
  color: "",
  piecesPerBox: null,
  sqmPerBox: null,
  fixtureType: "",
  fixturePosition: "",
  finish: "",
  material: "",
  lengthMm: null,
  mlPerBox: null,
  widthCm: null,
  heightCm: null,
  notes: "",
  // [sc-49299] giacenza iniziale: scatole/confezioni o pezzi
  boxQuantity: "",
  inWarehouse: "",
});

/**
 * Campi del nuovo articolo [sc-49299]. Chi lo usa legge `payload()` per
 * salvare e ascolta `update:valido` per accendere il pulsante.
 */
export default {
  name: "FormArticolo",
  components: { StatusSelect },
  props: {
    category: { type: String, required: true },
    // testo già scritto nella ricerca del preventivo
    nomeIniziale: { type: String, default: "" },
  },
  emits: ["update:valido"],
  data() {
    return {
      articleStatusOptions: [
        { value: "attivo", label: "Attivo", color: "#059669" },
        { value: "novita", label: "Novità", color: "#2563eb" },
        { value: "discontinuo", label: "Discontinuo", color: "#9ca3af" },
      ],
      fixtureTypeOptions: [
        { value: "", label: "— scegli —" },
        { value: "vaso", label: "Vaso", icon: "fa-toilet" },
        { value: "bidet", label: "Bidet", icon: "fa-water" },
        // [sc-48893] tipi nuovi, assegnati anche ai sanitari del FILE UNICO
        { value: "coprivaso", label: "Coprivaso", icon: "fa-toilet-paper" },
        { value: "cassetta", label: "Cassetta", icon: "fa-box-archive" },
        { value: "lavabo", label: "Lavabo", icon: "fa-droplet" },
        { value: "box doccia", label: "Box doccia", icon: "fa-shower" },
        { value: "piatto doccia", label: "Piatto doccia", icon: "fa-grip" },
        { value: "vasca", label: "Vasca", icon: "fa-bath" },
        {
          value: "mobile bagno",
          label: "Mobile bagno",
          icon: "fa-layer-group",
        },
        { value: "specchiera", label: "Specchiera", icon: "fa-image" },
        { value: "rubinetteria", label: "Rubinetteria", icon: "fa-faucet" },
        { value: "accessorio", label: "Accessorio", icon: "fa-puzzle-piece" },
        { value: "decoro", label: "Decoro", icon: "fa-gem" },
        { value: "idraulica", label: "Idraulica", icon: "fa-wrench" },
        { value: "altro", label: "Altro", icon: "fa-circle-question" },
      ],
      fixturePositionOptions: [
        { value: "", label: "— scegli —" },
        { value: "sospeso", label: "Sospeso", icon: "fa-arrow-up" },
        { value: "terra", label: "A terra", icon: "fa-arrow-down" },
        { value: "mono-blocco", label: "Mono-blocco", icon: "fa-cube" },
        { value: "nessuno", label: "Nessuno", icon: "fa-ban" },
        { value: "altro", label: "Altro", icon: "fa-circle-question" },
      ],
      form: formVuoto(this.category, this.nomeIniziale),
    };
  },
  computed: {
    categoryGroup() {
      return getCategoryGroup(this.category);
    },
    giacenza() {
      return campoGiacenza(this.category);
    },
    erroreScontato() {
      return erroreScontato(this.form.price, this.form.priceDiscounted);
    },
    caricaGiacenza() {
      return puoCaricareGiacenza(this.$store.state.currentUser?.role);
    },
    erroreGiacenza() {
      if (!this.caricaGiacenza) return null;
      return erroreGiacenzaIniziale(this.category, this.form);
    },
    unitaVendita() {
      return unitaPerCategoria(this.category, this.form.salesUnit);
    },
    vendita() {
      return controlloVendita(this.form);
    },
    valido() {
      return (
        (this.form.itemCode || "").trim().length > 0 &&
        haNomeOBrand(this.form) &&
        this.vendita.completo &&
        !this.erroreScontato &&
        !this.erroreGiacenza
      );
    },
  },
  watch: {
    // categoria cambiata («Modifica categoria»): l'unità torna quella di partenza
    category(nuova) {
      if (
        !unitaPerCategoria(nuova).some((u) => u.value === this.form.salesUnit)
      )
        this.form.salesUnit = unitaIniziale(nuova);
    },
    valido: {
      handler(v) {
        this.$emit("update:valido", v);
      },
      immediate: true,
    },
  },
  methods: {
    avvisoUnita,
    richiesto,
    /** Dati da mandare a item/create: solo la giacenza della categoria. */
    payload() {
      const { boxQuantity, inWarehouse, ...campi } = this.form;
      const giacenza = { boxQuantity, inWarehouse }[this.giacenza.campo];
      return {
        ...campi,
        // null, non 0: uno scontato a 0 vorrebbe dire "gratis"
        priceDiscounted: numeroPrezzo(this.form.priceDiscounted),
        category: this.category,
        ...(this.caricaGiacenza ? { [this.giacenza.campo]: giacenza } : {}),
      };
    },
    reset() {
      this.form = formVuoto(this.category);
    },
  },
};
</script>

<style>
/* [sc-49299] note ed errori sotto i campi, nella pagina e nella finestra */
.form-articolo {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-articolo .help-note {
  color: #6b7280;
  font-size: 12px;
}

/* [sc-49299] unità di vendita insolita per la categoria */
.form-articolo .help-warning {
  color: #b45309;
  font-size: 12px;
}

.form-articolo .help-error {
  color: #e6492d;
  font-size: 12px;
}

.form-articolo .field input.invalid {
  border-color: #e6492d;
}
</style>
